import { Link } from 'react-router-dom';

const featuredProjects = [
  {
    title: 'Lake Geneva Commercial Tower',
    sector: 'Real Estate',
    location: 'Geneva, Switzerland',
    value: '€340M',
    return: '14.2%',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20commercial%20glass%20skyscraper%20in%20Geneva%20Switzerland%2C%20reflecting%20Lake%20Geneva%20and%20Alps%20mountains%2C%20warm%20golden%20hour%20light%2C%20premium%20architectural%20photography%2C%20clean%20professional%20aesthetic%2C%20bright%20blue%20sky%2C%20corporate%20elegance&width=700&height=480&seq=portfolio-geneva-001&orientation=landscape',
  },
  {
    title: 'Andalusia Solar Farm Complex',
    sector: 'Renewable Energy',
    location: 'Seville, Spain',
    value: '€210M',
    return: '11.8%',
    image: 'https://readdy.ai/api/search-image?query=Massive%20solar%20farm%20in%20southern%20Spain%20with%20thousands%20of%20panels%20under%20bright%20sun%2C%20rolling%20hills%20in%20background%2C%20clean%20energy%20infrastructure%2C%20professional%20aerial%20style%20photography%2C%20warm%20golden%20tones%2C%20renewable%20energy%20investment&width=700&height=480&seq=portfolio-solar-002&orientation=landscape',
  },
  {
    title: 'North Sea Gas Terminal',
    sector: 'Oil & Gas',
    location: 'Rotterdam, Netherlands',
    value: '€180M',
    return: '13.5%',
    image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20gas%20processing%20terminal%20near%20port%2C%20clean%20metallic%20infrastructure%2C%20bright%20daylight%2C%20blue%20sky%20with%20soft%20clouds%2C%20professional%20industrial%20photography%2C%20energy%20infrastructure%2C%20warm%20steel%20and%20amber%20tones&width=700&height=480&seq=portfolio-gas-003&orientation=landscape',
  },
];

export default function PortfolioPreviewSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-18">
          <div>
            <span className="text-[10px] uppercase tracking-[3px] text-primary-500 font-semibold">
              Featured Investments
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 mt-4 tracking-tight">
              Portfolio Highlights
            </h2>
          </div>
          <Link
            to="/portfolio"
            className="mt-6 md:mt-0 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm uppercase tracking-[2px] font-semibold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            View Full Portfolio
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Project Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredProjects.map((project) => (
            <div
              key={project.title}
              className="group bg-white rounded-2xl overflow-hidden border border-foreground-100/30 hover:border-primary-300/40 transition-all duration-500 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm text-foreground-900 text-[10px] uppercase tracking-[2px] font-bold px-3 py-1.5 rounded-full">
                  {project.sector}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
                  {project.title}
                </h3>
                <div className="flex items-center gap-2 text-foreground-400 text-xs mb-4">
                  <i className="ri-map-pin-line" />
                  <span>{project.location}</span>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-foreground-100/30">
                  <div>
                    <p className="text-[10px] uppercase tracking-[2px] text-foreground-300 font-medium">Value</p>
                    <p className="text-lg font-heading font-bold text-foreground-950">{project.value}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] uppercase tracking-[2px] text-foreground-300 font-medium">Projected Return</p>
                    <p className="text-lg font-heading font-bold text-accent-600">{project.return}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}